import Header from "../Header";
import SongQueue from "./SongQueue/SongQueue";
import {
	makeStyles,
	Typography,
	Snackbar,
	Button,
	DialogContent,
	Dialog,
	DialogTitle,
	IconButton, Grid, Slider, Container
} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import SearchBar from "./SearchBar";
import {Alert} from "@material-ui/lab";
import firebase from 'firebase';
import VotingQueue from "./VotingQueue/VotingQueue";
import NowPlaying from "./NowPlaying";
import HostTab from "./Tab/HostTab";
import UserTab from "./Tab/UserTab"
import SpotifyPlayer from "../../controllers/SpotifyPlayer";
import axios from "axios";
import {withRouter} from "react-router"
import QRCode from 'qrcode.react'
import CloseIcon from '@material-ui/icons/Close';
import HelpDialog from "../HelpDialog";
import {addToState, clearState, getState, removeFromState} from "../../controllers/stateController";
import {VolumeDown, VolumeUp} from "@material-ui/icons";


const useStyles = makeStyles((theme) => ({
	title: {
		alignSelf: "flex-start",
	},
	textInput: {
		background: "white",
		color: "black",
		fontSize: "x-large",
		fontWeight: "bold",
	},
	inputGroup: {
		display: "flex",
		margin: theme.spacing(2),
		flexDirection: "column",
	},
	qr: {
		margin: theme.spacing(2),
		backgroundColor: theme.palette.primary.main
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: "black",
	},
	votingQueue: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	cast: {
		width: 24,
		height: 24,
		// use this to apply a contrastText if your theme
		// is unusual
		// '--disconnected-color': '#995533'
	},
}));


const handleRemove = (song) => {
	axios.post(global.API_URL + "/remove-song", {
		token: getState().apiToken,
		songId: song.spotify_id
	}).catch(error => {
		console.log(error)
	});
}

// vote functions
const handleVote = (song) => {
	if (hasVotedAlready(song)) {
		axios.post(global.API_URL + "/vote-song", {
			token: getState().apiToken,
			songId: song.spotify_id
		}).catch(error => {
			console.log(error)
		});
	}
}

const hasVotedAlready = (song, doAdd = true) => {
	let votedSongs = getState().voted_for_songs
	if (votedSongs === undefined ||
		votedSongs[`${getState().room_code}`] === undefined) {
		if (doAdd) {
			let voted = {}
			voted[`${getState().room_code}`] = {}
			voted[`${getState().room_code}`][`${song.spotify_id}`] = 0
			addToState({voted_for_songs: voted})
		}
		return true
	} else if (getState().voted_for_songs[`${getState().room_code}`][song.spotify_id] !== 0) {
		if (doAdd) {
			votedSongs[`${getState().room_code}`][`${song.spotify_id}`] = 0
			addToState({voted_for_songs: votedSongs})
		}
		return true
	}

	return false
}

function Dashboard({ history }) {
	const classes = useStyles();

	const [alertOpen, setAlertOpen] = useState(false);
	const [alertSeverity, setAlertSeverity] = useState("info");
	const [alertMessage, setAlertMessage] = useState("");

	const [room, setRoom] = useState({});
	const [user, setUser] = useState({});

	const [qrCodeOpen, setQrCodeOpen] = useState(false);
	const [volume, setVolume] = React.useState(100);

	useEffect(() => {
		// init firebase room sub
		const db = firebase.firestore();
		global.room_subscription = db.collection("rooms").doc(getState().room_code)
			.onSnapshot((doc) => {
				// if room was deleted
				if(doc.data() === undefined) {
					leaveSession()
				}

				// if no next song
				else if(doc.data().queue === undefined || doc.data().queue[0] === undefined) {
					addToState({
						next_song: {
							"uri": "",
							"offset": 0
						}})
				}
				// if next song changes
				else {
					addToState({
						next_song: {
							"uri": doc.data().queue[0].albumUri,
							"offset": doc.data().queue[0].albumOffset
						}})
				}

				// check for playlist end
				if(doc.data() !== undefined
				&& doc.data().playlist_id === ""
				&& getState().selected_playlist !== undefined) {
					removeFromState(["selected_playlist"])
				}

				setRoom(doc.data())
			}, error => {})

		// get updates on new access token
		global.user_subscription = db.collection("users").doc(getState().user_id)
			.onSnapshot((doc) => {
				if(doc.data() !== undefined && getState().role === "host") {
					addToState({access_token: doc.data().access_token})
				}
				// if user is kicked then leave
				if(doc.data() === undefined) {
					leaveSession()
				}
				else {
					setUser(doc.data())
				}
			}, error => {})
		// eslint-disable-next-line react-hooks/exhaustive-deps
		}, []
	);

	// handle volume change
	const handleChange = (event, newValue) => {
		if(newValue <= 0) newValue = 0.01;
		if(newValue > 100)  newValue = 100;
		setVolume(newValue);
		global.player.setVolume(newValue / 100);
	};

	// handle alert close
	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setAlertOpen(false);
	};

	// create a new alert of type "error", "warning", "info", or "success"
	const createAlert = (message, severity) => {
		setAlertSeverity(severity)
		setAlertMessage(message)
		setAlertOpen(true)
	}

	const leaveSession = () => {
		axios.post(global.API_URL +"/leave-room", {token: getState().apiToken})
			.catch(function (error) {
				console.log(error)
			})
		global.room_subscription()
		global.user_subscription()
		clearState(["voted_for_songs"])
		history.push("/")
	}

	return (
		<div>
			<Header showTitle={false}
				right={
					getState().role === "host"
						? <HostTab roomInfo={room} />
						: <UserTab leaveSession={() => leaveSession()} user={user}/>
			}
					left={
						<div>
							<Button onClick={() => setQrCodeOpen(true)}>
								<Typography variant="h6" color="initial" style={{letterSpacing: "2px"}}>
									<b>{getState().room_code}</b>
								</Typography>
							</Button>
							<Dialog onClose={() => setQrCodeOpen(false)} aria-labelledby="customized-dialog-title" open={qrCodeOpen} classes={{paper: classes.qr}}>
								<DialogTitle disableTypography>
									<Typography variant="h6" color={"secondary"}>SHARE ROOM CODE</Typography>
									<IconButton aria-label="close" className={classes.closeButton} onClick={() => setQrCodeOpen(false)}>
										<CloseIcon />
									</IconButton>
								</DialogTitle>
									<DialogContent dividers>
										<QRCode
											value={`https://${window.location.host}/${getState().room_code}`}
											bgColor="#1db954"
											fgColor="black"
											level="M"
											size={256}
										/>
									</DialogContent>
							</Dialog>

						</div>

					}
			/>
			{getState().role === "host"
				?
				<Container maxWidth={false} style={{margin: "10px 0 -20px 0"}}>
					<Grid container style={{alignItems: "center"}} spacing={2}>
						<Grid item>
							<VolumeDown />
						</Grid>
						<Grid item xs>
							<Slider value={volume} onChange={handleChange} aria-labelledby="continuous-slider" />
						</Grid>
						<Grid item>
							<VolumeUp />
						</Grid>
					</Grid>
				</Container>
				: null
			}
			<SearchBar createAlert={(m, s) => createAlert(m, s)}/>
			<NowPlaying now_playing={room.now_playing}/>
			<div className={classes.queue}>
				<Typography variant="body1" color="initial">
					<b>Next Songs</b>
				</Typography>
				<SongQueue queue={room.queue === undefined ? [] : room.queue}
						   handleVote={(s) => handleVote(s)}
						   hasVotedAlready={(s, e) => hasVotedAlready(s, e)}
						   handleRemove={(s) => handleRemove(s)}/>
			</div>
			<div>
				<div className={classes.votingQueue}>
					<Typography variant="body1" color="initial">
						<b>Vote for Songs</b>
					</Typography>
					<HelpDialog
						type={"dialog"}
						text={"Like a song to vote for it. Songs with the most votes get played next!"}/>
				</div>
				<VotingQueue
					queue={room.voting_queue === undefined ? [] : room.voting_queue}
					handleVote={(s) => handleVote(s)}
					hasVotedAlready={(s, e) => hasVotedAlready(s, e)}
					handleRemove={(s) => handleRemove(s)}
				/>
			</div>
			<Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleClose} id="snackbar">
				<Alert onClose={handleClose} severity={alertSeverity} id="alert">
					{alertMessage}
				</Alert>
			</Snackbar>
			{getState().role === "host" ? <SpotifyPlayer/> : null}
		</div>
	);
}

export default withRouter(Dashboard);
